import {
    Fare,
    FlightCard,
    FlightRouteInfo,
    FlightSegment,
    JsonsData,
    Sectors,
    SRPBaggageRequest
} from '@/src/types/flight'
import { convertDDMMYYYYToISO } from '@/src/utils/date/convertDateFormat'

export const getSRPBaggageRequest = (
    card: FlightCard,
    urlQueryObj: any,
    sectors: Sectors,
    formatDate: any,
    jsons: JsonsData,
    sFare?: Fare
): SRPBaggageRequest => {
    if (!card) {
        throw new Error('Invalid flight card data')
    }

    return {
        sc: {
            adt: Number(urlQueryObj.adults),
            chd: Number(urlQueryObj.childs),
            inf: Number(urlQueryObj.infants),
            intl: jsons.searchType?.isIntl ?? false,
            scr: jsons.searchType?.sellCurr,
            sct: jsons.searchType?.sellingCountry,
            stype: 'B2C',
            usrId: jsons?.userInfo?.usrId ?? "",
        },
        sol: buildSolutionFromCard(card, sectors, formatDate, sFare)
    }
}

const buildSolutionFromCard = (card: FlightCard, sectors: Sectors, formatDate: any, sFare?: Fare) => {
    const fare = sFare || (card.priceBreakup.fare as Fare)
    const bc = fare.bc?.split(',')
    let cabinType = 'Economy'
    const fl = card.sectorKeys.map(sectorKey => {
        const sector: FlightRouteInfo = sectors[sectorKey]
        const segments = sector.flights.segments.map((segment: FlightSegment, index) => {
            cabinType = segment.flightClass
            const [airLineCode, _] = segment.flightNumber.split('-')
            return convertSegment(segment, bc?.[index] || bc?.at(0) || "", fare.fb, fare.fk, airLineCode)
        })
        return {
            seg: segments
        }
    })

    const fre = {
        fk: fare.fk,
        ctype: cabinType?.charAt(0),
        ncib: fare.ncib,
        mi: false
    }

    return [
        {
            fl,
            fre
        }
    ]
}

const convertSegment = (
    segment: FlightSegment,
    bc: string,
    fareBasisCode: string,
    fareKey: string,
    airlineCode: string
) => {
    // Combine date and time to create the required format
    const departureDateTime = `${convertDDMMYYYYToISO(segment.departure.date)} ${segment.departure.time}`
    const arrivalDateTime = `${convertDDMMYYYYToISO(segment.arrival.date)} ${segment.arrival.time}`

    const segmentObj: any = {
        dep: segment.departure?.airportCode,
        arr: segment.arrival?.airportCode,
        dd: departureDateTime,
        ad: arrivalDateTime,
        fn: segment.flightNumber?.split('-')[1],
        al: airlineCode,
        oa: segment.oa,
        bc: bc
    }

    if (fareBasisCode) {
        segmentObj.fareBasisCode = fareBasisCode
    }
    if (fareKey) {
        segmentObj.fareKey = fareKey
    }

    return segmentObj
}
